import React from "react";
import ReactPlayer from "react-player";
import { OurGoalsData } from "./common/Helper";

const OurGoals = () => {
  return (
    <>
      <div id="react-player-goals-video" className="position-relative">
        <ReactPlayer
          className="react-player"
          url="https://vz-e28eac45-f0a.b-cdn.net/e6868d8a-c911-489c-9077-32fafc11e8d0/playlist.m3u8"
          width="100%"
          playing={true}
          loop={true}
          muted={true}
          height="100%"
        />
        <div className="position-absolute h-100 w-100 align-items-center top-0">
          <div>
            <h3 className="text-uppercase ff_josfin font-2xl fw-normal color-light-white position-absolute pt-5 goals_heading_text w-100 text-center text-lg-start">
              our goals & vision
            </h3>
          </div>
          <div className="d-md-flex justify-content-md-end justify-content-center h-100 overflow_hidden mt-sm-5 pt-5 mt-5 pt-sm-4 pt-lg-0 mt-md-0 bg_security">
            {OurGoalsData.map((val, i) => {
              return (
                <div
                  className={` d-sm-flex w-100 justify-content-around mb-0 mb-sm-4 mb-md-0 goals_blur_hover bg-gradient-white_goals ${
                    i === 0 ? "mt-5 mt-md-0" : ""
                  } `}
                  key={i}
                >
                  <div className="d-flex align-items-center justify-content-center mt-3 mb-sm-0">
                    <div className="px-2 px-lg-4 goals_text_parent py-3 py-md-0">
                      <div className="numbers_min_height">
                        <h2 className="font-4xl fw-normal ff_josfin color-white text_border text-center mb-0">
                          {val.number}
                        </h2>
                      </div>
                      <p
                        className={`${
                          i < 2 ? "" : ""
                        } text-uppercase color-light-white font-lg font-medium mb-0 text-center ff_josfin`}
                      >
                        {val.para}
                      </p>
                      <p className="font-sm fw-normal color-light-white pt-md-4 goals_para_hover text-center ">
                        {val.para2}
                      </p>
                    </div>
                  </div>
                </div>
              );
            })}
            <a
              className="position-absolute bottom-0 mb-4 me-4 text-decoration-none ff_josfin fw_500 font-lg color-light-white end-0"
              href="#"
            >
              Learn More!
            </a>
          </div>
        </div>
      </div>
    </>
  );
};

export default OurGoals;
